"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPageSmall = void 0;
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    logo: {
        display: 'block',
        margin: '30px auto',
        height: 100,
    },
    card: {
        width: 300,
        margin: 'auto',
    },
});
function AppPageSmall({ children }) {
    const { logoBlack } = (0, useAppState_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { alt: "", className: myCss.logo, src: logoBlack }),
        react_1.default.createElement(Pane_1.default, { classes: { root: myCss.card } }, children)));
}
exports.AppPageSmall = AppPageSmall;
exports.default = AppPageSmall;
